import { render, staticRenderFns } from "./fooTrelevancy.vue?vue&type=template&id=6440c11a&scoped=true&"
import script from "./fooTrelevancy.vue?vue&type=script&lang=js&"
export * from "./fooTrelevancy.vue?vue&type=script&lang=js&"
import style0 from "./fooTrelevancy.vue?vue&type=style&index=0&id=6440c11a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6440c11a",
  null
  
)

export default component.exports